import ExpandDownModule from '@tdcerhverv/parrotfish/icons/ExpandDown';
import { icon } from './interop';

const Expand_down = icon(ExpandDownModule);

export const ExpandDownIcon = (
  <Expand_down
    style={{
      fill: 'currentColor',
      width: '0.75em',
      height: '0.75em',
      display: 'inline-block',
      fontSize: 'inherit',
      flexShrink: 0,
    }}
  />
);
